import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OrderWarehouseConfigFieldsFragmentDoc } from '../fragments/orderWarehouseConfig.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrderWarehouseConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrderWarehouseConfigQuery = { __typename?: 'Query', getOrderWarehouseConfig: { __typename?: 'OrderWarehouseConfig', non_event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> }, event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> } } };


export const GetOrderWarehouseConfigDocument = gql`
    query GetOrderWarehouseConfig {
  getOrderWarehouseConfig {
    ...OrderWarehouseConfigFields
  }
}
    ${OrderWarehouseConfigFieldsFragmentDoc}`;

/**
 * __useGetOrderWarehouseConfigQuery__
 *
 * To run a query within a React component, call `useGetOrderWarehouseConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderWarehouseConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderWarehouseConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrderWarehouseConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderWarehouseConfigQuery, GetOrderWarehouseConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderWarehouseConfigQuery, GetOrderWarehouseConfigQueryVariables>(GetOrderWarehouseConfigDocument, options);
      }
export function useGetOrderWarehouseConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderWarehouseConfigQuery, GetOrderWarehouseConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderWarehouseConfigQuery, GetOrderWarehouseConfigQueryVariables>(GetOrderWarehouseConfigDocument, options);
        }
export type GetOrderWarehouseConfigQueryHookResult = ReturnType<typeof useGetOrderWarehouseConfigQuery>;
export type GetOrderWarehouseConfigLazyQueryHookResult = ReturnType<typeof useGetOrderWarehouseConfigLazyQuery>;
export type GetOrderWarehouseConfigQueryResult = Apollo.QueryResult<GetOrderWarehouseConfigQuery, GetOrderWarehouseConfigQueryVariables>;